var inquiry = {
    chatBotAvtars: {
        chatBotAvtar: [
            "https://firebasestorage.googleapis.com/v0/b/chatbot-production-d6ea3.appspot.com/o/chatbotavtaar%2Fchatbotavatar3.svg?alt=media&token=f6319d10-02fb-490c-892a-8b49a553fcc2",
            "https://firebasestorage.googleapis.com/v0/b/chatbot-production-d6ea3.appspot.com/o/chatbotavtaar%2Fchatbotavatar2.svg?alt=media&token=8b7982ab-0060-472b-ad51-6792e3fba162",
            "https://firebasestorage.googleapis.com/v0/b/chatbot-production-d6ea3.appspot.com/o/chatbotavtaar%2Fchatbotavatar1.svg?alt=media&token=fe41f944-828d-47af-bfcc-d14d14af0956",
        ],
    },
    template_One: {
        0: {
            UI: "Welcome Message",
            Validation: {
                doValidate: false,
                type: "",
            },
            action: "",
            continue: true,
            data: {
                text: "Hi! I am Snappy, a friendly bot, and I am here to assist you.",
            },
            input: "",
            next: 9,
            trigger: [],
            parentNode : -1
        },
        1: {
            UI: "Get Name",
            Validation: {
                doValidate: true,
                loop: 0,
                successful: 2,
                type: "Name",
            },
            action: "",
            continue: false,
            data: {
                responseText: "Great! Thanks for providing your name.",
                text: "Before we send your query to the concerned team we'd appreciate if you can provide your name?",
            },
            input: "",
            next: null,
            trigger: [],
            parentNode : 13
        },
        2: {
            UI: "Bot Message",
            Validation: {
                doValidate: false,
                loop: 0,
                type: "",
            },
            action: "",
            continue: true,
            data: {
                text: "Great! Thanks for providing your name.",
            },
            input: "",
            next: 3,
            trigger: [],
            parentNode : 1
        },
        3: {
            UI: "Get Email",
            Validation: {
                doValidate: true,
                loop: 0,
                successful: 5,
                type: "Email",
                unsuccessful: 4,
                text: "Now please tell me your email ID, so that we can stay in touch, even in future!",
            },
            action: "",
            continue: false,
            data: {
                successful: "Great! Thanks for the email ID, now we don't have to worry about getting disconnected.",
                text: "Now please tell me your email ID, so that we can stay in touch, even in future!",
                unsuccessful: {
                    failedAttemptsFinal: "Oops! Looks like you are entering an invalid email address. We usually accept business email ids only like abc@appypiellp.com",
                    failedAttemptsText: "Oops! Looks like you entered an invalid email address. Please give me a valid email address.",
                    no_of_email: "",
                    nonBusinessCheck: "",
                    nonBusinessEmails: [],
                    spamMailCheck: "",
                    spamMailText: [],
                },
            },
            input: "",
            next: null,
            trigger: [],
            parentNode : 2
        },
        4: {
            UI: "Get Email",
            Validation: {
                doValidate: true,
                loop: 0,
                successful: 5,
                type: "Email",
                unsuccessful: 4,
                text: "Now please tell me your email ID, so that we can stay in touch, even in future!",
            },
            action: "",
            continue: false,
            data: {
                text: "Oops! Looks like you entered an invalid email address. Please give me a valid email address.",
            },
            input: "",
            next: null,
            trigger: [],
        },
        5: {
            UI: "Bot Message",
            Validation: {
                doValidate: false,
                loop: 0,
                type: "",
            },
            action: "",
            continue: true,
            data: {
                text: "Great! Thanks for the email ID, now we don't have to worry about getting disconnected.",
            },
            input: "",
            next: 6,
            trigger: [],
            parentNode : 3
        },
        6: {
            UI: "Get Phone",
            Validation: {
                doValidate: true,
                loop: 0,
                successful: 8,
                type: "Phone",
                unsuccessful: 7,
                text: "Please share your contact number.",
            },
            action: "",
            continue: false,
            data: {
                successful: {
                    botResponseCheck: "",
                    botResponseText: "Great! Thanks for the number.",
                    countrycode: "",
                },
                text: "Please share your contact number.",
                unsuccessful: {
                    botResponseUnCheck: "",
                    botResponseUnText: "Oops! Looks like you entered an invalid contact number. Please give me a valid one.",
                    botResponseUsTextFinal: "Thanks for the number.",
                    no_of_repeatQuestion: "",
                },
            },
            input: "",
            next: null,
            trigger: [],
            parentNode : 5
        },
        7: {
            UI: "Get Phone",
            Validation: {
                doValidate: true,
                loop: 0,
                successful: 8,
                type: "Phone",
                unsuccessful: 7,
                text: "Please share your contact number.",
            },
            action: "",
            continue: false,
            data: {
                text: "Oops! Looks like you entered an invalid contact number. Please give me a valid one.",
            },
            input: "",
            next: null,
            trigger: [],
        },
        8: {
            UI: "Bot Message",
            Validation: {
                doValidate: false,
                loop: 0,
                type: "",
            },
            action: "",
            continue: true,
            data: {
                text: "Great! Thanks for the number.",
            },
            input: "",
            next: 15,
            trigger: [],
            parentNode : 6
        },
        15: {
            UI: "Bot Question",
            Validation: {
                doValidate: true,
                loop: 0,
                successful: "14",
                type: "question",
            },
            action: "",
            continue: false,
            data: {
                responseText: "Great! Thanks for the information.",
                text: "Lastly, Please provide your inquiry.",
            },
            input: "",
            next: null,
            trigger: [],
            parentNode : 8
        },
        9: {
            UI: "Bot Question",
            Validation: {
                doValidate: true,
                loop: 0,
                successful: "13",
                type: "question",
            },
            action: "",
            continue: false,
            data: {
                responseText: "Great! Thanks for the information.",
                text: "How can I help you?",
            },
            input: "",
            next: null,
            trigger: [],
            parentNode : 0
        },
        10: {
            UI: "Handoffs",
            Validation: {
                doValidate: false,
                type: "",
            },
            action: "SaveInquiry",
            continue: true,
            data: {
                handoffs: {
                    appy_email: {
                        id: 0,
                        type: "Email",
                        title: "Appy Email",
                        data: {
                            email: "",
                        },
                    },
                },
                text: "Great! Thanks for the informations.",
            },
            input: "",
            next: 12,
            trigger: [],
            parentNode : 14
        },
        11: {
            UI: "End Message",
            Validation: {
                doValidate: false,
                type: "",
            },
            action: "SaveInquiry",
            continue: false,
            data: {
                text: "Great! Thanks for the information.",
            },
            input: "",
            next: null,
            trigger: [],
            parentNode : 12
        },
        12: {
            UI: "Feedback",
            Validation: {
                doValidate: false,
                loop: 0,
                type: "",
            },
            action: "feedback",
            continue: false,
            data: {
                feedback_type: {
                    presentation: {
                        label: "1 to 5 scale",
                        value: "1-5",
                    },
                    type: {
                        label: "Scale",
                        value: "rating-scale",
                    },
                },
                isEnable: true,
                responseText: "Thank you for the feedback.",
                text: "Please rate your conversation with Snappy.",
            },
            input: "",
            next: 11,
            trigger: [],
            parentNode : 10
        },
        13: {
            UI: "Bot Message",
            Validation: {
                doValidate: false,
                loop: 0,
                type: "",
            },
            action: "",
            continue: true,
            data: {
                text: "Great! Thanks for the information.",
            },
            input: "",
            next: 1,
            trigger: [],
            parentNode : 9
        },
        14: {
            UI: "Bot Message",
            Validation: {
                doValidate: false,
                loop: 0,
                type: "",
            },
            action: "",
            continue: true,
            data: {
                text: "Thanks for providing your details. We've forwarded your inquiry to the concerned team. Someone will get back to you soon.",
            },
            input: "",
            next: 10,
            trigger: [],
            parentNode : 15
        },

        "00": {
            Validation: {
                doValidate: false,
                type: "",
            },
            action: "",
            continue: false,
            input: "",
            message: "null",
            next: 0,
            trigger: [],
        },
        customisation: {
            backgroundChatBot: "#FFFFFF",
            botButtonColor: "#2c3049ff",
            botButtonText: "lora",
            botButtonTextColor: "#FFFFFF",
            botTextcolor: "#000",
            chatBotAvtar: "https://firebasestorage.googleapis.com/v0/b/chatbot-production-d6ea3.appspot.com/o/chatbotavtaar%2Fchatbotavatar3.svg?alt=media&token=f6319d10-02fb-490c-892a-8b49a553fcc2",
            clientBubbleClr: "#2c3049ff",
            clientchattextcolor: "#ffffff",
            designLanguage: "english(en)",
            designPage: "default",
            headerClr: "#2c3049ff",
            headerName: "Inquiry bot",
            headertextcolor: "#ffffff",
            messagebubble: "#0606064d",
            sendButtonClr: "#2c3049ff",
            textfonts: "roboto",
            widgetBackgroundColor: "#2c3049ff",
            widgetImage: "https://firebasestorage.googleapis.com/v0/b/chatbot-production-d6ea3.appspot.com/o/widgetIcon%2Fchatbotavatar3.svg?alt=media&token=6a39c949-c97b-4811-9414-c21c2e249985",
            widgetPosition: {
                bottom: "8",
                position: "right",
                side: "8",
            },
            widgetSize: "large",
        },
        time: 1562221203801,
    },
    widgetImages: {
        widgetImage: [
            "https://firebasestorage.googleapis.com/v0/b/chatbot-production-d6ea3.appspot.com/o/widgetIcon%2Fchatbotavatar3.svg?alt=media&token=6a39c949-c97b-4811-9414-c21c2e249985",
            "https://firebasestorage.googleapis.com/v0/b/chatbot-production-d6ea3.appspot.com/o/widgetIcon%2Fchatbotavatar2.svg?alt=media&token=eda6ee3f-a82e-405d-91cc-ae80ae5910d0",
            "https://firebasestorage.googleapis.com/v0/b/chatbot-production-d6ea3.appspot.com/o/widgetIcon%2Fchatbotavatar1.svg?alt=media&token=23fb8ec9-5129-4c87-b060-cc0fe84e9377",
            "https://firebasestorage.googleapis.com/v0/b/chatbot-production-d6ea3.appspot.com/o/widgetIcon%2Fwidget2.svg?alt=media&token=210ce6f4-f9ef-475c-a757-d08cd1d84467",
            "https://firebasestorage.googleapis.com/v0/b/chatbot-production-d6ea3.appspot.com/o/widgetIcon%2Fwidget1.svg?alt=media&token=782bf939-6627-4f33-ae1a-a9f6e9cf8c1f",
            "https://firebasestorage.googleapis.com/v0/b/chatbot-production-d6ea3.appspot.com/o/widgetIcon%2Fwidget3.svg?alt=media&token=49981112-ba7b-48e6-90f0-4cd8486b97a2",
        ],
    },
};




export default inquiry;